import React, { useState } from "react";
import Modal from "../../elements/front/Modal";
import Avatar from "../../form/front/Avatar";

const ReactionLiksModal = ({ isOpen, onClose, postId }) => {
    const [user, setUser] = useState([]);
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
            title={"People who liked this Post"}
            titleClass={"text-base md:!text-lg"}
            bodyClasses="md:pr-2"
        >
             <div className="max-h-[70vh] overflow-y-auto">
            {
                Array.from({ length: 50 }).map((item, index) => (
                    <div
                        key={index}
                        className="flex items-start gap-3 py-3 border-b border-gray-200">
                        <Avatar
                            image={`https://i.pravatar.cc/150?u=${Math.random()}`}
                            name={"SM"}
                            size={38}
                        />


                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-1">
                                <h4 className="text-[14px] font-semibold text-gray-900 leading-[1.2] truncate">
                                    Sangita Manna {" "}
                                </h4>
                                <span className="text-[12px] text-gray-500 whitespace-nowrap">
                                    (2m)
                                </span>
                                <span className="text-xs text-gray-600 items-center">
                                    <i class="fa-duotone fa-solid fa-earth-africa"></i>
                                </span>
                            </div>

                            <p className="text-[12.5px] text-gray-600 leading-[1.3] mt-[2px] line-clamp-2">
                                Forest Engineer | AFOLU VVB @Earthood | VCS | CCB | GS | BCR | Social Carbon | Cercarbono
                            </p>
                        </div>
                    </div>
                ))
            }
            </div>
        </Modal>
    );
};

export default ReactionLiksModal;
